module.exports = __webpack_public_path__ + "static/media/Desc_arquitetos_de_negocios_profissao_do_futuro-06.a45c654f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetodenegocios/Desc_arquitetos_de_negocios_profissao_do_futuro-06.png
// module id = 289
// module chunks = 0